import React, { Component } from "react";
import { connect } from "react-redux";
import { config } from "../../_config/_config";
class Footer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="outer_application_form">
        <footer>
          <div className="footer-contnr">
            <div className="wrapper">
              <section className="container">
                <ul className="footer-links">
                  <li>
                    <h4>Forestry</h4>
                    <h5>
                      <a
                        href={config.mainUrl + "/forestry/controlled-burning/"}
                        className="links"
                      >
                        Controlled Burning
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={config.mainUrl + "/forestry/mechanical-services/"}
                        className="links"
                      >
                        Mechanical Services
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={config.mainUrl + "/forestry/manual-services/"}
                        className="links"
                      >
                        Manual Services
                      </a>
                    </h5>
                  </li>
                  <li>
                    <h4>Fire Safety </h4>
                    <h5>
                      <a
                        href={
                          config.mainUrl + "/fire-safety/insurance-industry/"
                        }
                        className="links"
                      >
                        Insurance Industry
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={
                          config.mainUrl +
                          "/fire-safety/hazardous-fuels-reduction/"
                        }
                        className="links"
                      >
                        Hazardous Fuels Reduction
                      </a>
                    </h5>
                  </li>
                  <li>
                    <h4>Emergency</h4>
                    <h5>
                      <a
                        href={config.mainUrl + "/emergency/all-risk/"}
                        className="links"
                      >
                        All Risk
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={
                          config.mainUrl + "/emergency/type-ii-ia-handcrews/"
                        }
                        className="links"
                      >
                        Crews
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={
                          config.mainUrl + "/emergency/wildland-fire-engines/"
                        }
                        className="links"
                      >
                        Engines
                      </a>
                    </h5>
                  </li>
                  <li>
                    <h4>Training</h4>
                    <h5>
                      <a
                        href={
                          config.mainUrl + "/training/certified-instructors/"
                        }
                        className="links"
                      >
                        Instructors
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={config.mainUrl + "/online-booking/"}
                        className="links"
                      >
                        Schedule
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={config.mainUrl + "/training/training-faqs/"}
                        className="links"
                      >
                        FAQs
                      </a>
                    </h5>
                  </li>
                  <li>
                    <h4>Employment</h4>
                    <h5>
                      <a
                        href={config.mainUrl + "/employment/"}
                        className="links"
                      >
                        Employment
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={config.mainUrl + "/employment-faqs/"}
                        className="links"
                      >
                        Employment FAQs
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={config.mainUrl + "/job-openings/"}
                        className="links"
                      >
                        Apply to Firestorm
                      </a>
                    </h5>
                  </li>

                  <li>
                    <h4>Firestorm</h4>
                    <h5>
                      <a href={config.mainUrl + "/about-us/"} className="links">
                        About Us
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={config.mainUrl + "/contact-us/"}
                        className="links"
                      >
                        Contact Us
                      </a>
                    </h5>
                    <h5>
                      <a
                        href={config.mainUrl + "/privacy-policy/"}
                        className="links"
                      >
                        Privacy Policy
                      </a>
                      <a
                        href={config.mainUrl + "/terms-of-use/"}
                        className="links terms"
                      >
                        | &nbsp;&nbsp;&nbsp;Terms
                      </a>
                    </h5>

                    <h5>
                      <a href={config.mainUrl + "/blog"} className="links">
                        Blog
                      </a>
                    </h5>
                  </li>
                </ul>

                <div className="connect-us">
                  <div className="head">Connect with us</div>
                  <a
                    href="http://www.yelp.com/biz/firestorm-wildland-fire-suppression-chico"
                    className="connect-link"
                    target="_blank"
                  >
                    <img
                      src="https://firestormfire.com/wp-content/themes/firestorm_v1/images/global/yelp.png"
                      alt="yelp"
                    />
                  </a>

                  <a
                    href="http://www.linkedin.com/company/firestorm-wildland-fire-suppression-inc-"
                    target="_blank"
                    className="connect-link"
                  >
                    <img
                      src="https://firestormfire.com/wp-content/themes/firestorm_v1/images/global/in.png"
                      alt="in"
                    />
                  </a>

                  <a
                    href="https://www.facebook.com/FirestormFire"
                    className="connect-link"
                    target="_blank"
                  >
                    <img
                      src="https://firestormfire.com/wp-content/themes/firestorm_v1/images/global/fb.png"
                      alt="facebook"
                    />
                  </a>

                  <div className="head">licenses &amp; memberships</div>

                  <a
                    href="http://www.chicochamber.com"
                    className="connect-link"
                    target="_blank"
                  >
                    <img
                      src="https://firestormfire.com/wp-content/themes/firestorm_v1/images/global/c.png"
                      alt="c"
                    />
                  </a>

                  <a
                    href="http://www.nwsa.us"
                    className="connect-link"
                    target="_blank"
                  >
                    <img
                      src="https://firestormfire.com/wp-content/themes/firestorm_v1/images/global/nwsa.png"
                      alt="nwsa"
                    />
                  </a>

                  <a
                    href="http://www.bbb.org/northeast-california/business-reviews/land-clearing-and-leveling/firestorm-wildland-fire-suppression-inc-in-chico-ca-33015142"
                    className="connect-link"
                    target="_blank"
                  >
                    <img
                      src="https://firestormfire.com/wp-content/themes/firestorm_v1/images/global/bbb.png"
                      alt="bbb"
                    />
                  </a>
                </div>
              </section>
            </div>
          </div>

          <div className="copyright-contnr">
            <div className="wrapper">
              <section className="container">
                <p>
                  © {new Date().getFullYear()} Copyright Firestorm Wildland Fire Suppression. All
                  rights reserved. &nbsp; -{" "}
                  <strong>
                    CSLB# 954861<strong> -</strong>
                  </strong>
                </p>
                <strong>
                  <strong>
                    <span>
                      Site Built by{" "}
                      <a href="http://whiterabbit.group/" target="_blank">
                        White Rabbit Group
                      </a>
                    </span>
                  </strong>
                </strong>
              </section>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(Footer);
export { connectedApp as Footer };
